function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useEffect, useCallback } from 'react';
import { LOGIN_ROUTE, LOGOUT_ROUTE, REGISTER_ROUTE, useCurrentUser, useLoggedIn } from '@immediate_media/auth-utils';
import useUserProfile from './use-user-profile';
import useSettings from './use-settings';

var useAccountSettings = function useAccountSettings(redirect) {
  var _settings$hub, _settings$hub4, _settings$hub5;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      accountSettings = _useState2[0],
      setAccountSettings = _useState2[1];

  var profileDetails = useUserProfile();
  var settings = useSettings();
  var isLoggedIn = useLoggedIn();

  var _useCurrentUser = useCurrentUser(),
      _useCurrentUser2 = _slicedToArray(_useCurrentUser, 2),
      currentUser = _useCurrentUser2[0],
      isLoadingCurrentUser = _useCurrentUser2[1];

  var _ref = ((_settings$hub = settings.hub) === null || _settings$hub === void 0 ? void 0 : _settings$hub.account) || {},
      myAccountDetails = _ref.details; // Adding fallback values here which are same as those in fabric-api-client.
  // This is currently techdebt and will be removed.
  // These values will remain after the techdebt is removed.


  var _ref2 = myAccountDetails || {},
      _ref2$label = _ref2.label,
      myAccountLabel = _ref2$label === void 0 ? 'Settings' : _ref2$label,
      _ref2$href = _ref2.href,
      myAccountHref = _ref2$href === void 0 ? '/user-settings' : _ref2$href;

  var getAccountMenu = useCallback(function () {
    if (isLoadingCurrentUser) {
      return [];
    }

    if (!isLoggedIn && !currentUser) {
      return [];
    }

    var menu = [{
      label: myAccountLabel,
      relativeUrl: myAccountHref,
      icon: 'cog'
    }, {
      label: 'Sign out',
      relativeUrl: LOGOUT_ROUTE,
      icon: 'door'
    }]; // Edge case, should never happen, but if the OIDC FES is down we still want to show
    // the user the option to sign out/access their settings (which will redirect to the login page)

    if (isLoggedIn && !currentUser) {
      return menu;
    }

    if (currentUser.vanityId && settings.hub && settings.hub.enabled) {
      if (settings.hub.ugc.enabled) {
        menu.unshift({
          label: settings.hub.ugc.label,
          relativeUrl: "/user/".concat(currentUser.vanityId, "/").concat(settings.hub.ugc.href)
        });
      }

      if (settings.hub.items) {
        _toConsumableArray(settings.hub.items).reverse().forEach(function (item) {
          menu.unshift({
            label: item.pluralLabel,
            relativeUrl: "/user/".concat(currentUser.vanityId, "/").concat(item.href)
          });
        });
      }

      menu.unshift({
        label: 'Overview',
        relativeUrl: "/user/".concat(currentUser.vanityId)
      });
    }

    return menu;
  }, [currentUser, isLoadingCurrentUser, isLoggedIn, myAccountHref, myAccountLabel, settings.hub]);
  useEffect(function () {
    var _settings$hub2, _settings$hub3;

    var query = redirect ? encodeURIComponent("?redirect=".concat(redirect)) : '';
    setAccountSettings({
      profileDetails: profileDetails,
      accountNavOptions: {
        label: (_settings$hub2 = settings.hub) !== null && _settings$hub2 !== void 0 && _settings$hub2.enabled && (_settings$hub3 = settings.hub) !== null && _settings$hub3 !== void 0 && _settings$hub3.header ? settings.hub.header : 'My Account',
        menuItems: getAccountMenu(),
        signInUrl: "".concat(LOGIN_ROUTE).concat(query),
        registerUrl: "".concat(REGISTER_ROUTE).concat(query),
        settingsUrl: "".concat(myAccountHref).concat(query)
      }
    });
  }, [getAccountMenu, myAccountHref, profileDetails, redirect, settings, (_settings$hub4 = settings.hub) === null || _settings$hub4 === void 0 ? void 0 : _settings$hub4.enabled, (_settings$hub5 = settings.hub) === null || _settings$hub5 === void 0 ? void 0 : _settings$hub5.header]);
  return accountSettings;
};

export default useAccountSettings;